export const LIST_MENU = 'LIST_MENU'

export function listMenuPrivilege(data) {
    return {type: LIST_MENU, data}
}